import { styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'
import { forwardRef } from 'react'

import { HandlerOf } from '../../helpers/typeHelper'
import { cyan, lightgreye3 } from '../../theme/colors'

const ToggleSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 48,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: cyan,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: cyan,
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: lightgreye3,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: lightgreye3,
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

export interface ToggleProps {
  value?: boolean
  onChange?: HandlerOf<boolean>
  name?: string
  disabled?: boolean
  errorMessage?: string | React.ReactElement
  className?: string
}

export const Toggle = forwardRef(({ value, onChange, ...rest }: ToggleProps, ref: any) => {
  const handleChange = (_: any, checked: boolean) => {
    onChange?.(checked)
  }

  return (
    <>
      <ToggleSwitch checked={value} onChange={handleChange} {...rest} ref={ref} />
    </>
  )
})
